// src/components/BoostMeCard.js
import React from 'react';
import './BoostMeCard.css'; // Importa el CSS para los estilos

const BoostMeCard = () => {
  return (
    <div className="card-container">
      <div className="card-content">
        <div className="logo">⚡</div>
        <h1>Boost me</h1>
        <div className="widget-text">
          <p>Si quieres apoyar mi trabajo, por favor, considera donar unos sats a mi dirección de lightning:</p>
        </div>
        <iframe
          src="https://www.bitflow.site/widget/eyJyZWNlaXZlclR5cGUiOiJsaWdodG5pbmciLCJyZWNlaXZlciI6InphcGVhbWVAZ2V0YWxieS5jb20iLCJhbW91bnRzIjoiMjE0LDMwMDAsNTAwMCIsImxhYmVscyI6IkJpdCxDYWbpLEJvb3N0IiwidGhlbWUiOiJvcmFuZ2UiLCJ1c2VDdXN0b21JbWFnZSI6dHJ1ZSwiaW1hZ2UiOiJhSFIwY0hNNkx5OWthV2RwZEdGc2MyOXNkV05wYjI1ekxtTnZiUzkzY0MxamIyNTBaVzUwTDNWd2JHOWhaSE12TWpBeU5TOHdOaTlpYVhSbWJHOTNMV0YyWVhSaGNpNXdibWMifQ"
          className="bitflow-widget"
          allow="clipboard-write"
          loading="lazy"
          title="BitFlow Widget"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};

export default BoostMeCard;